angular.module('impactx.rfx').controller('RFXBuyerCancelCtrl', [
    'TranslationService',
    '$mdDialog',
    'dataGen',
    RFXBuyerCancelCtrl
]);

function RFXBuyerCancelCtrl(TranslationService, $mdDialog, dataGen) {
    var self = this;
    self.reason = "";
    self.saveTrns = TranslationService.get('save');
    self.abortTrns = TranslationService.get('abort');

    self.save = function () {
        return dataGen.postAsForm({}, {id: self.rfqhId, reason: self.reason, rework: self.rework}, '/rfx/buyer/cancel').then(function () {
            $mdDialog.hide();
        });
    };

    self.abort = function () {
        $mdDialog.cancel();
    };
}